import React, {useEffect, useRef, useState} from 'react';
import {map} from 'lodash';

import OneRow from './OneRow';
import STableHeader from './STableHeader';
import STablePage from './STablePage';

export default function ({dataStudentTable, selectPage}) {

    const renderRows = () => {
        return map(dataStudentTable.items, (one_student, k) => {
            return (
                <OneRow
                    key={k}
                    one_student={one_student}
                />
            );
        });
    }

    return (
        <div id="pam-challenge-student-table">
            <div className="student-table-title">
                {`Individual Student Achievement - Math Practices/ELA Targets`}
            </div>

            <div>
                <table className="student-table-main">
                    <STableHeader
                        dataStudentTable={dataStudentTable}
                    />

                    <tbody>
                        {renderRows()}
                    </tbody>
                </table>
            </div>

            <div>
                <STablePage
                    dataStudentTable={dataStudentTable}
                    selectPage={selectPage}
                />
            </div>
        </div>
    );
}
